/*
 * @Description:
 * @Author: wjx
 * @Github:
 * @LastEditors: wjx
 * @Date: 2019-03-29 13:49:26
 * @LastEditTime: 2019-03-29 16:53:47
 */
import Config from "@/config/index"
const AUTHKEY = Config.token
export function getToken() {
  return localStorage.getItem(AUTHKEY)
}
export function setToken(tokenValue) {
  localStorage.setItem(AUTHKEY, tokenValue)
}
export function delToken() {
  localStorage.removeItem(AUTHKEY)
}
export function getUserDetail(){
  return JSON.parse(window.localStorage.getItem('user|detail'))
}
